import { remember, remembered } from '@/lib/remember'

// How an album's photos are laid out on this device: as tiles (the usual) or one after another as a feed. Its third
// view, Story, is the album's Storybook version on its own page, so it's never the one an album opens in.
export const ALBUM_VIEWS = ['feed', 'tiles'] as const
export type AlbumView = (typeof ALBUM_VIEWS)[number]
export const ALBUM_VIEW_KEY = 'gatheredfrom:album-view'

export const savedAlbumView = () => remembered(ALBUM_VIEW_KEY, ALBUM_VIEWS, 'tiles')
export const saveAlbumView = (view: AlbumView) => remember(ALBUM_VIEW_KEY, view)
